import { useState } from "react";

import {
  ContentCopy as ContentCopyIcon,
  MoreVert as MoreVertIcon,
} from "@mui/icons-material";
import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import copy from "clipboard-copy";
import PropTypes from "prop-types";

import { formatDateTime } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { getReportOverlayContainer } from "../report-frame/fullscreen";

/** Technical details of the applied report, kept out of the way until support needs them. */
export const ReportInfoMenu = ({ metadata }) => {
  const { showSnackbar } = useSnackbar();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleCopyId = async () => {
    setAnchorEl(null);
    try {
      await copy(metadata.reportId);
      showSnackbar("ID laporan disalin.", "success");
    } catch {
      showSnackbar("ID laporan tidak dapat disalin.", "error");
    }
  };

  return (
    <>
      <Tooltip title="Info laporan">
        <IconButton
          size="small"
          aria-label="Info laporan"
          onClick={(event) => setAnchorEl(event.currentTarget)}
        >
          <MoreVertIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        container={getReportOverlayContainer}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleCopyId}>
          <ListItemIcon>
            <ContentCopyIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText
            primary="Salin ID laporan"
            secondary={`${metadata.reportId} · ${formatDateTime(metadata.generatedAt)}`}
          />
        </MenuItem>
      </Menu>
    </>
  );
};

ReportInfoMenu.propTypes = {
  metadata: PropTypes.shape({
    reportId: PropTypes.string.isRequired,
    generatedAt: PropTypes.string.isRequired,
  }).isRequired,
};
